<div class="navbar" [style.background-color]="backgroundColor">
  <div class="brand">
    <ng-content select="[brand]"></ng-content>
  </div>

  <div class="start">
    <ng-content select="[start]"></ng-content>
  </div>

  <div class="end">
    <ng-content select="[end]"></ng-content>
  </div>
</div>
